




















import { Component, Vue, Prop } from "vue-property-decorator";
import { ReportData } from "@/types";
import FormatServicesAnimationLine from "./FormatServicesAnimationLine";

@Component({
  name: "FormatServices",

  components: {
    FormatServicesAnimationLine,
  },
})
export default class FormatServices extends Vue {
  @Prop({ type: Array, required: true }) items!: Array<ReportData>;
  @Prop() totalValue!: number;

  get maxValue() {
    return Math.max(...this.items.map((item) => item.value));
  }

  get sortedItems() {
    return [...this.items].sort((a, b) => b.value - a.value);
  }
}
